/**
 * Network calls for lead forms: optional file staging (presign → PUT to S3),
 * then the submission itself.
 */
import axios from "axios";
import { api } from "@/services/api";

export const UPLOAD_ACCEPT = ".pdf,.docx,.jpg,.jpeg,.png";
export const UPLOAD_MIME_TYPES = [
  "application/pdf",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "image/jpeg",
  "image/png",
];
export const UPLOAD_MAX_BYTES = 10 * 1024 * 1024;
export const UPLOAD_MAX_FILES = 5;

export function newSubmissionId() {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }
  // RFC 4122 v4 fallback for older browsers.
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
  });
}

/** Upload files to S3 staging; resolves to the staging keys in file order. */
export async function stageFiles(submissionId, files, onProgress) {
  if (!files.length) return [];
  const { uploads } = await api.post("/v2/uploads/presign", {
    submission_id: submissionId,
    files: files.map((f) => ({ filename: f.name, size: f.size, mime_type: f.type })),
  });
  const loaded = files.map(() => 0);
  const total = files.reduce((sum, f) => sum + f.size, 0) || 1;
  await Promise.all(
    uploads.map((upload, i) =>
      axios.put(upload.url, files[i], {
        headers: { "Content-Type": upload.content_type },
        timeout: 120000,
        onUploadProgress: (e) => {
          loaded[i] = e.loaded;
          if (onProgress) onProgress(loaded.reduce((a, b) => a + b, 0) / total);
        },
      })
    )
  );
  return uploads.map((u) => u.key);
}

export function postLead(body) {
  return api.post("/v2/leads", body);
}
